import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleFileUploaderComponent } from './single-file-uploader.component';
import { ButtonModule } from '../../../ui/button/button/button.module';
import { UploadModule } from '../../upload.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [SingleFileUploaderComponent],
  exports: [SingleFileUploaderComponent],
  imports: [
    CommonModule,
    ButtonModule,
    UploadModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatMenuModule,
  ],
})
export class SingleFileUploaderModule {}
